import http from '../http'
import { Res } from '../type'
import {
  CourseCatetoryParams,
  CourseHomeParams,
  CourseSummaryParams,
  CourseSummarry,
  CourseHome,
  CourseCatetory,
  CourseWareDetails,
  CourseDetailParams,
  CourseDetail,
  ICourseStartParams,
  ICourseFinishParams,
  ICourseUpdateParams,
  ICourseStart,
  ICourseFinish,
  ICourseUpdate,
  ICourseListParams,
  ICourseList,
  Goods,
  IResourcePageParams,
  IResourcePage,
  IInteractiveInitParams,
  IInteractiveAnswerParams,
  IInteractiveRestartParams,
  IInteractiveCompleteParams,
  IInteractionInitResponse,
  IInteractiveAnswerResponse,
  IInteractiveRestartResponse,
  IInteractiveCompleteResponse,
  ICourseWareVersionParams,
  ICourseWareVersionResponse
} from '../Models/CourseDetail'

// 课程首页
export const postCourseHome = (data: CourseHomeParams, loadingShow: '0' | '1' | undefined): Res<CourseHome> => {
  return http.request({
    url: '/sands-lms/api/v1/online-class-summary/page',
    method: 'post',
    data,
    loadingShow
  })
}

// 课程分类商品
export const postClassGoods = (data: { classificationId: string }, loadingShow: '0' | '1' | undefined): Res<Goods> => {
  return http.request({
    url: '/sands-lms/api/v1/online-class-summary/classGoods',
    method: 'post',
    data,
    loadingShow
  })
}

// 课程首页tree
export const postCourseCatetory = (data: CourseCatetoryParams): Res<CourseCatetory> => {
  return http.request({
    url: '/sands-lms/api/v1/course-category/tree',
    method: 'post',
    data,
    loadingShow: data.loadingShow
  })
}

// 课程搜索页
export const postCourseSummaryList = (data: CourseSummaryParams): Res<CourseSummarry> => {
  return http.request({
    url: '/sands-lms/api/v1/online-class-summary/page',
    method: 'post',
    loadingShow: '0',
    data
  })
}

// 课程包详情
export const postCourseDetail = (data: CourseDetailParams): Res<CourseDetail> => {
  return http.request({
    url: '/sands-lms/api/v1/course/courseDetail',
    method: 'post',
    data,
    loadingShow: data.loadingShow as '0' | '1' | undefined
  })
}

// 目录
export const postCourseContents = (data: CourseDetailParams): Res<CourseDetail> => {
  return http.request({
    url: '/sands-lms/api/v1/course/contents',
    method: 'post',
    data,
    loadingShow: '0',
    toastShow: '0'
  })
}

// 课件详情
export const postCourseWareDetail = (data: CourseDetailParams): Res<CourseWareDetails> => {
  return http.request({
    url: '/sands-lms/api/v1/course-ware/courseWareDetail',
    method: 'post',
    data,
    loadingShow: data.loadingShow as '0' | '1' | undefined
  })
}

// 开始学习
export const postCourseStart = (data: ICourseStartParams): Res<ICourseStart> => {
  return http.request({
    url: '/sands-lms/api/v1/learning-details/create',
    method: 'post',
    data
  })
}

// 交互式课件初始化
export const postInteractiveInit = (
  data: IInteractiveInitParams,
  loadingShow: '0' | '1' | undefined = '1'
): Res<IInteractionInitResponse> => {
  return http.request({
    url: '/sands-lms/api/v1/course-ware/interactive/init',
    method: 'post',
    data,
    loadingShow
  })
}

// 交互式课件提交答案
export const postInteractiveAnswer = (
  data: IInteractiveAnswerParams,
  loadingShow: '0' | '1' | undefined = '1'
): Res<IInteractiveAnswerResponse> => {
  return http.request({
    url: '/sands-lms/api/v1/course-ware/interactive/answer',
    method: 'post',
    data,
    loadingShow,
    toastShow: '0'
  })
}

// 交互式课件重学
export const postInteractiveRestart = (
  data: IInteractiveRestartParams,
  loadingShow: '0' | '1' | undefined = '1'
): Res<IInteractiveRestartResponse> => {
  return http.request({
    url: '/sands-lms/api/v1/course-ware/interactive/restart',
    method: 'post',
    data,
    loadingShow
  })
}

// 交互式课件完成
export const postInteractiveComplete = (
  data: IInteractiveCompleteParams,
  loadingShow: '0' | '1' | undefined = '1'
): Res<IInteractiveCompleteResponse> => {
  return http.request({
    url: '/sands-lms/api/v1/course-ware/interactive/complete',
    method: 'post',
    data,
    loadingShow
  })
}

// 完成学习
export const postCourseFinish = (data: ICourseFinishParams): Res<ICourseFinish> => {
  return http.request({
    url: '/sands-lms/api/v1/learning-details/finish',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

// 更新学习
export const postCourseUpdate = (data: ICourseUpdateParams): Res<ICourseUpdate> => {
  return http.request({
    url: '/sands-lms/api/v1/learning-details/update',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

// 学习详情(学员端)相关接口-我的学习详情(分页)
export const postMyCourseList = (data: ICourseListParams): Res<ICourseList> => {
  return http.request({
    url: '/sands-lms/api/v1/learning-details/page',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

/**
 * 系统资源分页：用于文档图片模式逐页取图
 */
export const postSystemResourcePage = (data: IResourcePageParams): Res<IResourcePage> => {
  return http.request({
    url: '/sands-system/api/v1/system/resource/page',
    method: 'post',
    data,
    loadingShow: '0',
    toastShow: '0'
  })
}

// 获取课件版本号
export const getCourseWareVersion = (data: ICourseWareVersionParams): Res<ICourseWareVersionResponse> => {
  return http.request({
    url: '/sands-lms/api/v1/course-ware/courseWareVersion',
    method: 'post',
    data,
    loadingShow: '0',
    toastShow: '0'
  })
}
